<template>
  <div class="htfbhtjf">
    <sec-title
      Text="合同纠纷"
      descText="四项选择，让你轻松应对"
      class="text_center"
    />
    <div class="htlist between">
      <div class="htitem text_center">
        <div><img src="../../../assets/jpcol/htfbhtjficon1.png" alt="" /></div>
        <div class="ht2">协商</div>
        <div class="ht3">
          和解是由争议各方根据合同约定的违约责任和各方实际情况，自行协商而不需通过司法程序解决纠纷的方式。和解是纠纷常见的解决方式
        </div>
      </div>

      <div class="htitem text_center">
        <div><img src="../../../assets/jpcol/htfbhtjficon2.png" alt="" /></div>
        <div class="ht2">仲裁</div>
        <div class="ht3">
          仲裁指争议各方根据合同中的仲裁条款或者纠纷发生以后达成的仲裁协议，将争议提交法定的仲裁机构，由仲裁机构依据仲裁规则居间进行居中调解，依法做出裁定的方式。当事人不愿和解、调解或者和解、调解不成的，均可申请
        </div>
      </div>
      <div class="htitem text_center">
        <div><img src="../../../assets/jpcol/htfbhtjficon3.png" alt="" /></div>
        <div class="ht2">诉讼</div>
        <div class="ht3">
          诉讼是解决合同争议的最后方式。是指人民法院根据争议双方的请求、事实和法律，依法做出裁判，藉此解决争议的方式。当事人没有订立仲裁协议或者仲裁协议无效的，可以向人民法院起诉
        </div>
      </div>
      <div class="htitem text_center">
        <div><img src="../../../assets/jpcol/htfbhtjficon4.png" alt="" /></div>
        <div class="ht2">调解</div>
        <div class="ht3">
          由争议各方选择信任的第三方居中，就合同争议进行调解处理。调解通常是以各方互谅互让为原则进行
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import secTitle from "views/home/components/secTitle";
export default {
  components: {
    secTitle,
  },
};
</script>

<style lang="scss" scoped>
.htfbhtjf {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0;
  .htlist {
    margin-top: 30px;
    .htitem {
      width: 260px;
      height: 330px;
      background: #ffffff;
      padding: 30px 25px;
      box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.07);
      border-radius: 4px;
      .ht2 {
        margin-top: 22px;
        font-size: 20px;
        color: #333333;
      }
      .ht3 {
        font-size: 14px;
        color: #666666;
        line-height: 24px;
        margin-top: 10px;
      }
    }
  }
}
</style>